var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c(
        "form",
        {
          ref: "form",
          attrs: {
            id: "pricing-form",
            name: "form",
            action: _vm.urlPrefix + "/pricing-form-submit",
            method: "POST",
          },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex center-xs space-top-1 md-space-top-2 space-bottom-1",
            },
            [
              _c("h2", { staticClass: "formstep-title maison-typo" }, [
                _vm._v(_vm._s(_vm.title)),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.showProgressBar
            ? _c("ProgressBar", {
                attrs: {
                  currentStep: _vm.currentStep,
                  totalSteps: _vm.currentSteps.length,
                  "custom-breakpoints": _vm.customBreakpoints,
                  breakpoints: _vm.breakpoints,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.currentStepData
            ? _c(_vm.getComponent, {
                tag: "Component",
                attrs: { step: _vm.currentStepData, order: _vm.stepOrder },
                on: {
                  progress: _vm.progress,
                  back: function ($event) {
                    return _vm.back()
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.formFields ? _c("HiddenFieldset") : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "center-xs start-s space-top-3 legal-container legal-text",
      domProps: { innerHTML: _vm._s(_vm.richText(_vm.legalText)) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }